import React, { Component } from 'react';
import { Button, Header, Popup, Segment, Table } from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import NonCycleProgramForm from './NonCycleProgramForm';
import { getProgramLeadFullName } from '../NonCycleStudentProfile/NonCycleStudentBasicInformation';

class NonCycleProgramBasicInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
        };
    }

    render() {
        const {
            program,
            onRefresh,
            isStudentService
        } = this.props;
        const { editing } = this.state;

        const enTranslation = program.translations
            ? program.translations.find(t => t.language === 'en') || {}
            : {};

        const formatDate = (ts) => ts ? moment(ts)
            .format('D. M. YYYY.') : '-';

        if (editing) {
            return (
                <NonCycleProgramForm
                    program={program}
                    onCloseForm={() => this.setState({ editing: false })}
                    onRefreshData={onRefresh}
                />
            );
        }

        const hasCertSupp = !!program.hasCertificateSupplement;

        return (
            <Segment.Group>
                <Segment>
                    <Header as="h3">
                        <Header.Content style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <div></div>
                            {isStudentService && (
                                <Popup
                                    content={<FormattedMessage id="externalStudent.editNonCycleProgram"/>}
                                    position="top center"
                                    trigger={
                                        <Button
                                            icon="pencil"
                                            circular
                                            basic
                                            color="green"
                                            size="mini"
                                            onClick={() => this.setState({ editing: true })}
                                        />
                                    }
                                />
                            )}
                        </Header.Content>
                    </Header>
                </Segment>
                <Segment>
                    <Table basic="very" compact celled>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programName"/>
                                </Table.Cell>
                                <Table.Cell>{program.programName || '-'}</Table.Cell>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programNameEn"/>
                                </Table.Cell>
                                <Table.Cell>{enTranslation.programName || '-'}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.nonCycleStudyProgramType"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {program.nonCycleStudyProgramType ? program.nonCycleStudyProgramType.name : '-'}
                                </Table.Cell>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programLead"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {getProgramLeadFullName(program)}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programAttendanceType"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {program.attendanceType ? program.attendanceType.name : '-'}
                                </Table.Cell>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.studyProgramLanguage"/>
                                </Table.Cell>
                                <Table.Cell>
                                    {program.languages && program.languages.length > 0
                                        ? program.languages.map(l => l.name)
                                            .join(', ')
                                        : '-'}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programDurationEcts"/>
                                </Table.Cell>
                                <Table.Cell>{program.maxEcts != null ? program.maxEcts : '-'}</Table.Cell>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programDurationMonths"/>
                                </Table.Cell>
                                <Table.Cell>{program.programDurationMonths != null ? program.programDurationMonths : '-'}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.dateFrom"/>
                                </Table.Cell>
                                <Table.Cell>{formatDate(program.dateFrom)}</Table.Cell>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.dateTo"/>
                                </Table.Cell>
                                <Table.Cell>{formatDate(program.dateTo)}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.comment"/>
                                </Table.Cell>
                                <Table.Cell>{program.comment || '-'}</Table.Cell>
                                <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                    <FormattedMessage id="externalStudent.programHasCertificateSupplementShort"/>
                                </Table.Cell>
                                <Table.Cell>{program.hasCertificateSupplement ?
                                    <FormattedMessage id={'common.yes'}/> :
                                    <FormattedMessage id={'common.no'}/>
                                }</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Segment>
                {hasCertSupp && (
                    <Segment secondary>
                        <Header as="h4">
                            <FormattedMessage id="externalStudent.additionalInformation"/>
                        </Header>
                        <Table basic="very" compact celled>
                            <Table.Body>
                                {(program.mainFieldOfStudy || enTranslation.mainFieldOfStudy) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.mainFieldOfStudy"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.mainFieldOfStudy || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.mainFieldOfStudyEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.mainFieldOfStudy || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                                {(program.programStructure || enTranslation.programStructure) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.programStructure"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.programStructure || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.programStructureEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.programStructure || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                                {(program.accessRequirements || enTranslation.accessRequirements) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.accessRequirements"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.accessRequirements || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.accessRequirementsEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.accessRequirements || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                                {(program.learningOutcomes || enTranslation.learningOutcomes) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.learningOutcomes"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.learningOutcomes || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.learningOutcomesEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.learningOutcomes || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                                {(program.professionalStatus || enTranslation.professionalStatus) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.professionalStatus"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.professionalStatus || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.professionalStatusEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.professionalStatus || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                                {(program.additionalInformation || enTranslation.additionalInformation) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.additionalInformation"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.additionalInformation || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.additionalInformationEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.additionalInformation || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                                {(program.sourcesOfAdditionalInformation || enTranslation.sourcesOfAdditionalInformation) && (
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.sourcesOfAdditionalInformation"/>
                                        </Table.Cell>
                                        <Table.Cell>{program.sourcesOfAdditionalInformation || '-'}</Table.Cell>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.sourcesOfAdditionalInformationEn"/>
                                        </Table.Cell>
                                        <Table.Cell>{enTranslation.sourcesOfAdditionalInformation || '-'}</Table.Cell>
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                    </Segment>
                )}
            </Segment.Group>
        );
    }
}

export default NonCycleProgramBasicInformation;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleProgram/NonCycleProgramBasicInformation.js